import yup from '../../../config/yup';

export const amazonRedshiftReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('amazonRedshiftReader'),
  delayedRead: yup.boolean(),
  connectionKey: yup.string(),
  parameterizedBy: yup.string(),
  properties: yup.object().shape({
    username: yup.string().transform((value) => value?.trim()),
    password: yup.string().transform((value) => value?.trim()),
    rootUrl: yup.string().transform((value) => value?.trim()),
    databaseName: yup
      .string()
      .required('Database name is required')
      .transform((value) => value.trim()),
    // JDBC properties
    driver: yup.string().required('Driver is required'),
    sqlQuery: yup
      .string()
      .required('SQL Query is required')
      .transform((value) => value.trim()),
    host: yup.string().required('Host is required'),
    port: yup.number().typeError('Port must be a number'),
  }),
});
